export enum Steps {
    step1,
    step2,
    step3
}
